<template>
  <div class="page about">
    
    <m-textarea class="about-main" :class="lngTxtClass" ref="content">
      <div :class="curretTabName" v-html="content"></div>
    </m-textarea>
    <BottomNav
      :page="page"
      :items="tabs"
      :class="lngClass"
      btnclass="about-nav"
      :icon="{iconUrlDefault, iconUrlActive}"
      @changeNav="changeTab"
      wrap
    ></BottomNav>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import BottomNav from "@/components/BottomNav.vue";
import TextArea from "@/components/TextArea.vue";

import iconUrlDefault from "@/assets/img/tab4-d.png";
import iconUrlActive from "@/assets/img/tab4-a.png";

export default {
  components: {
    BottomNav,
    "m-textarea": TextArea
  },
  data() {
    return {
      page: "about",
      iconUrlDefault,
      iconUrlActive,
      currentTab: 0,
      curretTabName: "chengyuan"
    };
  },
  computed: {
    ...mapState({
      about: "about",
      tabs: state => state.tabs.about,
      locale: "locale"
    }),
    ...mapGetters(["lngClass"]),
    content() {
      const tabData = this.about[this.curretTabName];
      return tabData ? tabData.content : "";
    },
    lngTxtClass() {
      return this.locale === "ru" ? this.lngClass + " ru-text" : this.lngClass;
    }
  },
  mounted() {
    this.getContent({
      page: this.page,
      tab: this.curretTabName
    });
  },
  methods: {
    ...mapActions(["getContent"]),
    changeTab(activeNum) {
      const tabName = this.tabs[activeNum].name;
      this.getContent({
        page: this.page,
        tab: tabName
      });
      this.currentTab = activeNum;
      this.curretTabName = tabName;
      this.$refs.content.scroll();
    }
  }
};
</script>

<style lang="scss">
@import "../assets/base";
.about {
  .bottom-nav.lng {
    bottom: 1rem;
    .about-nav span {
      white-space: normal;
    }
  }
}
.about-main {
  height: 25rem;
  margin: 1.5rem 2rem;
  .textarea {
    height: 60vh;
  }
  div {
    margin-bottom: 1rem;
  }
  &.lng {
    margin-left: 1rem;
    margin-right: 1rem;
  }
  &.ru-text {
    h3 {
      font-weight: 500;
    }
  }
}
.about-nav .icon {
  width: 12px;
  height: 12px;
}
.chengyuan {
  margin-right: -1rem;

  @include title-h3(1rem);

  p {
    display: flex;
    flex-wrap: wrap;
    width: 23em;
    font-size: 0.75rem;
    line-height: 1.8;

    span {
      display: block;
      margin-right: 1rem;
    }

    i {
      font-style: normal;
      border: 0.5px solid $text;
    }
  }

  .about-main.lng & {
    p {
      width: 100%;
    }
    span {
      width: 36vw;
    }
  }
}
.mingxie {
  font-size: 0.875rem;

  strong {
    display: block;
    font-weight: 900;
  }
}
.shengming {
  font-size: 0.875rem;
  li {
    margin-bottom: 1rem;
  }
}
.contact {
  margin-right: -1rem;
  font-size: 0.875rem;

  td {
    vertical-align: top;
  }

  td:first-child {
    width: 6rem;
  }

  .about-main.lng & {
    margin-left: -1rem;
    td:first-child {
      width: auto;
      padding-right: 1rem;
      white-space: nowrap;
    }
  }
}
</style>
